import * as Sentry from '@sentry/vue'
import type { App } from 'vue'

import type { AppEnv } from '@/shared/config'

let sentryReady = false

// Sentry hook stub (contract 01 §14). No-op until a DSN is provided (open question §18 —
// reuse the org project vs a new v4 project). Richer wiring (router tracing, release,
// user context) lands with the shell (module 05).
export function installSentry(app: App, env: AppEnv): void {
  sentryReady = false
  if (!env.SENTRY_DSN) return
  Sentry.init({
    app,
    dsn: env.SENTRY_DSN,
    environment: env.MODE,
    tracesSampleRate: 0,
  })
  sentryReady = true
}

/** App-owned vendor seam for feature telemetry; remains a no-op when Sentry is disabled. */
export function recordSentryBreadcrumb(
  category: string,
  message: string,
  data?: Record<string, string | number>,
): void {
  if (!sentryReady) return
  Sentry.addBreadcrumb({ category, message, level: 'warning', ...(data ? { data } : {}) })
}
